<template>
  <div id="app" :style="{ overflowY: isLiveStyle ? 'hidden' : 'auto' }">
    <section class="main" ref="main" :style="{ position: isLiveStyle ? '' : 'relative' }">
      <Header v-show="!isLiveStyle" :liveRoute="liveRoute"/>
      <router-view :key="$route.fullPath" />
    </section>
    <FullScreenPop></FullScreenPop>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import GetUtils from "./utils/utils";
import Header from "@/components/Common/Header.vue";
import FullScreenPop from "@/components/DialogPop/FullScreenPop";
export default {
  name: "app",
  data() {
    return {
      isLiveStyle: false,
      liveRoute: false
    };
  },
  components: {
    Header,
    FullScreenPop
  },
  created() {
    this.getUserInfoFn(); //获取用户信息
    this.getLevelInfo(); //获取等级信息
    this.getGiftList(); //获取礼物配置信息
    this.postDamuConfig(); //获取飞屏配置信息
    this.postTryConfig(); //获取试看配置信息
    this.getScrollAdver({ keys: "live_scroll_msg_config" }); //获取直播间滚动消息
    this.getTopAdver({ keys: "live_top_msg_config" }); //获取直播间顶置消息
    this.getPreviewConfig({ keys: "live_closed_img" }); //获取直播间预览信息
    this.getVideo_domain({keys: "playback_video_domain"}) //获取直播回放视频域名
    this.postGetAdver({code: "index_top_float",page: 1, page_size: 10}) //获取首页广告
    this.postGetAdList({code: "common_game_recommend",page: 1, page_size: 10}) //获取推荐游戏
    if(GetUtils.getUrlKey("productId")) {
      this.$store.commit('SET_CHANNEL_STATE', GetUtils.getUrlKey("productId"))
    }else {
       this.$store.commit('SET_CHANNEL_STATE', 'ONEGAME')
    }
    if(GetUtils.getUrlKey("directLive") === '1') {
      this.$store.commit('SET_DIRECT_LIVE', true)
    }
    if(GetUtils.getUrlKey("isMatchLive") === '1') {
      this.$store.commit('SET_IS_MATCH_LIVE', true)
      sessionStorage.setItem('isMatchLive', true)
    }
    if (GetUtils.getUrlKey("enterFrom")) {
      this.$store.commit('SET_ENTER_FROM', GetUtils.getUrlKey("enterFrom"))
    }
    if (localStorage.getItem("mainSwitch")) {
      //获取保存的特效按钮状态
      this.$store.commit(
        "SET_MAIN_SWITCH",
        JSON.parse(localStorage.getItem("mainSwitch"))
      );
    }
    // this.$store.commit('SET_TIME_ENTER', new Date())
  },
  destroyed() {
  },
  beforeDestroy() {
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.info.userInfo,
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.path.includes("/room")) {
          this.isLiveStyle = true;
          this.lockOrientationPortrait();
        } else {
          this.isLiveStyle = false;
          this.unlockOrientation();
        }
        if( to.path.includes("/article") || to.path.includes("/preview")) {
          this.liveRoute = true
        }else {
          this.liveRoute = false
        }
      },
    },
  },
  methods: {
    /** 锁定为竖屏：用户物理横屏手机时页面不随设备旋转，只能通过点击横屏按钮进入横屏模式 */
    lockOrientationPortrait() {
      if (typeof screen !== 'undefined' && screen.orientation && typeof screen.orientation.lock === 'function') {
        screen.orientation.lock('portrait').catch(() => {});
      }
    },
    unlockOrientation() {
      if (typeof screen !== 'undefined' && screen.orientation && typeof screen.orientation.unlock === 'function') {
        try {
          screen.orientation.unlock();
        } catch (e) {}
      }
    },
    ...mapActions({
      getUserInfoFn: "getUserInfoFn",
      getLevelInfo: "getLevelInfo",
      getGiftList: "getGiftList",
      getScrollAdver: "getScrollAdver",
      getTopAdver: "getTopAdver",
      postDamuConfig: "postDamuConfig",
      getPreviewConfig: "getPreviewConfig",
      getVideo_domain: "getVideo_domain",
      postTryConfig: "postTryConfig",
      postGetAdver: "postGetAdver",
      postGetAdList: "postGetAdList"
    }),
  },
};
</script>
<style lang="scss">
html {
  scrollbar-width: thin;
  scrollbar-color: #a1c4fd rgba(240,240,240,0.5);
}
html,
body {
  margin: 0;
  padding: 0;
}
html,
body {
  font-family: "NotoSans", "PingFang SC", "Helvetica Neue", "Microsoft YaHei",
    Arial, Helvetica, sans-serif !important;

  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.blueStyle {
  width: 6.93333rem !important;
  background: linear-gradient(180deg, #40479b 0%, #222565 100%);
  box-shadow: 0px -1px 4px 0px rgba(28, 28, 28, 0.5);
  background-color: transparent !important;
  .van-dialog__header {
    color: #ffd01e;
  }
  .van-dialog__message {
    color: #fff;
  }
  .van-button--default {
    background-color: #2d3279;
  }
  .van-dialog__cancel {
    color: #919699;
  }
  .van-dialog__confirm {
    color: #ebedf0;
  }
}
.blueSp {
  .van-dialog__message {
    padding-left: 0.28rem;
    padding-right: 0.28rem;
  }
}
#app {
  // -ms-overflow-style: none;  /* IE 和 Edge */
  // scrollbar-width: none;     /* Firefox */
  overscroll-behavior: none;
  scroll-behavior: smooth;
  // &::-webkit-scrollbar {
  //    display: none;
  // }
  background: linear-gradient(180deg,#27277a,#4854a3 50%,#33368a);
}

/* 强制横屏：仅 /room 路由使用，由 liveBar 在直播间内控制添加 class，离开路由会移除 */
html.force-landscape {
  overflow: hidden;
}
html.force-landscape body {
  overflow: hidden;
}
html.force-landscape #app {
  position: fixed;
  width: 100vh;
  height: 100vw;
  top: 50%;
  left: 50%;
  margin-left: -50vh;
  margin-top: -50vw;
  transform: rotate(90deg);
  transform-origin: center center;
  overflow: auto;
  z-index: 9999;
}

/* 横屏时 UI 层挂到 body 下，避免 iOS 上声网视频盖住；与 #app 同旋、更高 z-index */
#landscape-ui-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  pointer-events: none;
}
#landscape-ui-overlay > * {
  pointer-events: auto;
  width: 100%;
  height: 100%;
}
html.force-landscape #landscape-ui-overlay {
  width: 100vh;
  height: 100vw;
  top: 50%;
  left: 50%;
  margin-left: -50vh;
  margin-top: -50vw;
  transform: rotate(90deg);
  transform-origin: center center;
}

/* 横屏时 Dialog/Toast 挂到 overlay，限制为与竖屏一致的宽高，避免铺满屏 */
html.force-landscape #landscape-ui-overlay .van-dialog {
  width: 320px !important;
  max-width: 90vmin !important;
  max-height: 40vmin !important;
  box-sizing: border-box;
}
html.force-landscape #landscape-ui-overlay .van-dialog__message {
  max-height: 40vmin !important;
}
html.force-landscape #landscape-ui-overlay .van-toast {
  width: auto !important;
  max-width: 70vmin !important;
  max-height: 10vmin !important;
  min-width: 96px !important;
  box-sizing: border-box;
}
</style>

